import { CatalogItem, ServiceCartridgeGroup } from '../catalog.model';
import { CartridgeStatus } from '../cartridges.models';
import { PriceRequestState } from '../enums/price-request-state';
import { BookingState } from '../enums/booking-state';
import { CatalogStage } from '@markant-platform/shared/content/model';
import { OrganizationType } from 'data-model';

export const MOCK_CATALOG_STAGE: CatalogStage = {
  elements: [
    {
      headline: 'test headline one',
      subline: 'GSDN',
      text: 'test text one',
      linkhref: {
        href: 'https://example.com/one',
        target: '_blank',
        text: 'test label one',
      },
    },
  ],
};

export const MOCK_CATALOG_ITEM: CatalogItem = {
  id: '67475b5c893f9d13a1fbbe77',
  name: 'Service Group Prototyp',
  description:
    'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.',
  icon: 'eservice_produktstammdaten_promis_positiv',
  serviceKey: 'PROTOTYPE',
  isServiceGroup: true,
  serviceCartridgeGroup: null,
  serviceGroup: {
    state: 'PARTIAL_BOOKED',
    numberBooked: 1,
    services: [
      {
        id: '63908b0f40aab46a5c4bb46c',
        name: 'Cartridge prototype',
        description: 'Prototype implementation of an external cartridge.',
        icon: 'eservice_archivierung_positiv',
        serviceKey: 'PROTOTYPE',
        isServiceGroup: false,
        serviceGroup: null,
        serviceCartridgeGroup: {
          priceRequestState: PriceRequestState.ACCEPTED,
          priceRequestType: 'ORDER_REQUEST',
          state: BookingState.ACCEPTED,
          status: CartridgeStatus.ACTIVE,
          variants: [
            {
              variantId: '1234e29544e9fd436c21be4f',
              contentId: '443',
              type: 'STANDARD',
              name: 'Cartridge prototype Variant 1',
              description: '<p>Description Variant 1</p>',
              longDescription: '<p>Long Description Variant 1</p>',
              variantFeatures: ['2324', '2326'],
              image: '',
              icon: 'eservice_kosten-rechnungs-workflow-positiv',
              price: {
                currency: 'EUR',
                centAmount: 20000,
                priceModel: 'SUBSCRIPTION',
                billingPeriod: 'MONTHLY',
                hasToBeRequested: false,
                targetAudience: {
                  organizationType: OrganizationType.DEALER,
                  ezr: false,
                },
              },
              prices: [
                {
                  currency: 'EUR',
                  centAmount: 20000,
                  priceModel: 'SUBSCRIPTION',
                  billingPeriod: 'MONTHLY',
                  hasToBeRequested: false,
                  targetAudience: {
                    organizationType: OrganizationType.DEALER,
                    ezr: false,
                  },
                },
              ],
              remoteEntry: 'http://localhost:4300/remoteEntry.js',
              contractPeriod: 6,
              allowUiBooking: true,
              allowEcsSelfBooking: false,
              requireIntegrationProject: true,
              variantStatus: CartridgeStatus.ACTIVE,
              setUpCost: {
                currency: 'EUR',
                centAmount: 29999,
                targetAudience: {
                  organizationType: OrganizationType.DEALER,
                  ezr: false,
                },
              },
            },
          ],
        },
      },
    ],
  },
};

export const MOCK_CATALOG_ITEM_2: CatalogItem = {
  description:
    'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.',
  icon: 'eservice_produktstammdaten_promis_positiv',
  id: '67475b5c893f9d13a1fbbe77',
  isServiceGroup: true,
  name: 'Service Group Prototyp',
  serviceCartridgeGroup: null,
  serviceGroup: {
    numberBooked: 0,
    services: [
      {
        description: 'Prototype implementation of an external cartridge.',
        icon: 'eservice_archivierung_positiv',
        id: '63908b0f40aab46a5c4bb46c',
        isServiceGroup: false,
        name: 'Cartridge prototype',
        serviceCartridgeGroup: {
          status: CartridgeStatus.ACTIVE,
          variants: [
            {
              allowEcsSelfBooking: false,
              allowUiBooking: true,
              type: 'STANDARD',
              calculationParameters: [
                'Up to 125 analyses, favorites and alarms can be saved in the personal area',
                '50,000 to 500,000 incoming goods delivery bills per year',
                'Maximum turnover of 10 million euros per year',
                '400 to 799 GTIN-target market combinations',
                'More than 60 products recorded per year',
                'Some other parameter\r\nWith new line',
              ],
              contentId: '443',
              contractPeriod: 6,
              description: '<p>Description Variant 1</p>',
              icon: 'eservice_kosten-rechnungs-workflow-positiv',
              image: '',
              longDescription: '<p>Long Description Variant 1</p>',
              name: 'Cartridge prototype Variant 1',
              price: {
                billingPeriod: 'MONTHLY',
                centAmount: 20000,
                currency: 'EUR',
                hasToBeRequested: false,
                priceModel: 'SUBSCRIPTION',
                targetAudience: {
                  ezr: false,
                  organizationType: OrganizationType.DEALER,
                },
              },
              prices: [
                {
                  billingPeriod: 'MONTHLY',
                  centAmount: 20000,
                  currency: 'EUR',
                  hasToBeRequested: false,
                  priceModel: 'SUBSCRIPTION',
                  targetAudience: {
                    ezr: false,
                    organizationType: OrganizationType.DEALER,
                  },
                },
              ],
              remoteEntry: 'http://localhost:4300/remoteEntry.js',
              requireIntegrationProject: true,
              setUpCost: {
                centAmount: 29999,
                currency: 'EUR',
                targetAudience: {
                  ezr: false,
                  organizationType: OrganizationType.DEALER,
                },
              },
              variantFeatures: ['2324', '2326'],
              variantId: '1234e29544e9fd436c21be4f',
              variantStatus: CartridgeStatus.ACTIVE,
            },
          ],
        } as ServiceCartridgeGroup,
        serviceGroup: null,
        serviceKey: 'PROTOTYPE',
      },
      {
        description: 'Prototype implementation of an external cartridge with bulk prices.',
        icon: 'eservice_archivierung_positiv',
        id: '63908b0f40aab46a5c4bb46d',
        isServiceGroup: false,
        name: 'Cartridge prototype (Bulk prices)',
        serviceCartridgeGroup: {
          status: CartridgeStatus.ACTIVE,
          variants: [
            {
              allowEcsSelfBooking: false,
              allowUiBooking: true,
              type: 'STANDARD',
              apis: [],
              contentId: '445',
              contractPeriod: 6,
              description: '<p>This variant provides an example for using a price tier (total).</p>',
              icon: 'eservice_personal_positiv',
              image: 'https://cdn-eu.aglty.io/markant/eInvoicing_AdobeStock_561762961_einfache%20Lizenz_markant.png',
              longDescription: '<p>This variant provides an example for using a price tier (total).</p>',
              name: 'Price Tier Variant (Total)',
              price: {
                billingPeriod: 'MONTHLY',
                bulkPrices: [],
                centAmount: 0,
                currency: 'EUR',
                priceModel: 'STAGGERED_FIXED_PRICE',
                targetAudience: {
                  ezr: false,
                  organizationType: OrganizationType.DEALER,
                },
              },
              prices: [
                {
                  billingPeriod: 'MONTHLY',
                  currency: 'EUR',
                  hasToBeRequested: false,
                  priceModel: 'STAGGERED_FIXED_PRICE',
                  targetAudience: {
                    ezr: false,
                    organizationType: OrganizationType.DEALER,
                  },
                  centAmount: 2000,
                },
                {
                  billingPeriod: 'NONE',
                  centAmount: 100000,
                  currency: 'EUR',
                  hasToBeRequested: false,
                  priceModel: 'FIXED_PRICE',
                  targetAudience: {
                    ezr: false,
                    organizationType: OrganizationType.SUPPLIER,
                  },
                },
              ],
              remoteEntry: 'http://localhost:4300/remoteEntry.js',
              requireIntegrationProject: false,
              variantId: '6648decf9a98211ee036f821',
              variantStatus: CartridgeStatus.ACTIVE,
              widgets: [],
            },
            {
              allowEcsSelfBooking: false,
              allowUiBooking: true,
              type: 'STANDARD',
              apis: [],
              contentId: '443',
              contractPeriod: 6,
              description:
                '<p>Description Variant 1  with a long title to test the capabilites of the UI to show adaptable cards</p>',
              icon: 'eservice_kosten-rechnungs-workflow-positiv',
              image: '',
              longDescription: '<p>Long Description Variant 1</p>',
              name: 'Roadtrip with the car YEARLY variant - subscription',
              price: {
                billingPeriod: 'MONTHLY',
                centAmount: 20000,
                currency: 'EUR',
                hasToBeRequested: false,
                priceModel: 'SUBSCRIPTION',
                targetAudience: {
                  ezr: false,
                  organizationType: OrganizationType.DEALER,
                },
              },
              prices: [
                {
                  billingPeriod: 'MONTHLY',
                  centAmount: 20000,
                  currency: 'EUR',
                  hasToBeRequested: false,
                  priceModel: 'SUBSCRIPTION',
                  targetAudience: {
                    ezr: false,
                    organizationType: OrganizationType.DEALER,
                  },
                },
                {
                  billingPeriod: 'NONE',
                  centAmount: 100000,
                  currency: 'EUR',
                  hasToBeRequested: false,
                  priceModel: 'FIXED_PRICE',
                  targetAudience: {
                    ezr: true,
                    organizationType: OrganizationType.SUPPLIER,
                  },
                },
              ],
              remoteEntry: 'http://localhost:4300/remoteEntry.js',
              requireIntegrationProject: true,
              variantId: '1234e29544e9fd436c21be6b',
              variantStatus: CartridgeStatus.ACTIVE,
              widgets: [],
            },
          ],
        } as unknown as ServiceCartridgeGroup,
        serviceGroup: null,
        serviceKey: 'PROTOTYPE',
      },
    ],
    state: 'NONE',
  },
  serviceKey: 'PROTOTYPE',
};
